import { Navigate, Route, Routes } from 'react-router-dom'

import { APP_VERSION } from 'common/utils/versionConstants'

import ConfigurationPage from './Configuration'
import UserManagementPage from './UserManagementPage'

const Settings = () => {
  return (
    <Routes>
      <Route path={'configuration'} element={<ConfigurationPage />} />
      <Route path={'user-management'} element={<UserManagementPage />} />
      <Route path={'version'} element={<PublicVersionDisplayPage />} />
      <Route path='*' element={<Navigate to='/' />} />
    </Routes>
  )
}

const PublicVersionDisplayPage = () => <div>{APP_VERSION}</div>

export default Settings
